import { render } from "./TreeFileView.vue?vue&type=template&id=2186d25f&ts=true"
import script from "./TreeFileView.vue?vue&type=script&lang=ts"
export * from "./TreeFileView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__